import toast from 'react-hot-toast';
import { declineProjectBid } from '~/api/projectBids';
import { logUserActivity, UserActivityTypes } from '~/api/user';
import { useMutation } from 'react-query';
import Modal from '~/components/Modal';
import { Button } from '~/components';
import { useProjectContext } from '~/hooks';


interface DeclineProjectBidModalProps {
  projectId: string;
  fetchProject: () => void;
  closeModal: () => void;
}

export default function DeclineProjectBidModal({
  projectId,
  fetchProject,
  closeModal
}: DeclineProjectBidModalProps) {
  const { project } = useProjectContext();
  const investorQueueRow = project?.investorQueue?.find((row: any) => row.projectId === projectId);
  const { mutateAsync: declineBid, status: declineBidStatus } = useMutation(
    async () => {
      await declineProjectBid(projectId);
    });

  const handleDeclineBid = async () => {
    try {
      await declineBid();

      logUserActivity({
        activityType: UserActivityTypes.INVESTOR_REJECTED,
        projectId,
        portfolioId: null,
        metadata: {
          investorName: investorQueueRow?.investor?.company?.name,
        },
      });

      //window.location.reload(); // hack because the project page is not updating
      toast.success('Project bid declined successfully.', { duration: 5000 });
      fetchProject();
      closeModal();
    }
    catch (error) {
      console.error('Error declining project bid:', error);
      toast.error('An error occurred while declining the project bid.', { duration: 5000 });
    }
  };
    
  return (
    <Modal 
      closeModal={declineBidStatus === 'loading' ? undefined : closeModal}
      allowClose={declineBidStatus !== 'loading'}
    >
      <Modal.Title>Decline project bid?</Modal.Title>
      <Modal.Content>
        <p>Are you sure you want to decline this project bid? This cannot be undone without contacting an administrator.</p>
      </Modal.Content>
      <Modal.Footer>
        <Button 
          primary 
          outlined 
          disabled={declineBidStatus === 'loading'} 
          onClick={closeModal}
        >
          Go back
        </Button>
        <Button 
          primary 
          loading={declineBidStatus === 'loading'} 
          disabled={declineBidStatus === 'loading'} 
          onClick={() => handleDeclineBid()}
        >
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
}